import { Routes, Route } from "react-router-dom";
import { NoMatch } from "../pages/NoMatch";
import { ProtectedLayout } from "../layouts/ProtectedLayout";
import { PublicLayout } from "../layouts/PublicLayout";
import { useAuth } from "../hooks/useAuth";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "../pages/Home";
import { MemoryGame } from "../pages/MemoryGame";
import { CorporateArtCollections } from "../pages/CorporateArtCollections";
import { LocationSurvey } from "../pages/LocationSurvey";

const Router = ({ application }) => {
    const { user, isAuthenticated, getUserDetailsNotAsync } = useAuth();
    const userData = getUserDetailsNotAsync();
    const path = "";
    const navigate = useNavigate();

    useEffect(() => {}, []);
    return (
        <Routes>
            <Route path="/" element={<PublicLayout />}>
                <Route path={path + "/"} element={<Home />} />
                <Route path={path + "/student-art-collection"} element={<Home />} />
                <Route path={path + "/corporate-art-collection"} element={<CorporateArtCollections />} />
                <Route path={path + "/installation-art-collection"} element={<CorporateArtCollections />} />
                <Route path={path + "/memory-game"} element={<MemoryGame />}></Route>
                <Route path={path + "/memory-game-gallery"} element={<MemoryGame />}></Route>
                <Route path="*" element={<NoMatch />} />
            </Route>

            <Route element={<ProtectedLayout />}>
                <Route path="*" element={<NoMatch />} />
            </Route>
        </Routes>
    );
};

export { Router };
